var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroplet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24219 20.4464C5.24219 14.3446 10.4642 8.31465 14.1295 4.83383C16.12 2.94341 19.156 2.94341 21.1466 4.83383C24.8118 8.31465 30.0338 14.3446 30.0338 20.4464C30.0338 26.4291 25.3398 32.5827 17.638 32.5827C9.93624 32.5827 5.24219 26.4291 5.24219 20.4464Z",
    stroke: "#F2FCF7",
    strokeWidth: 2.1875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4701 20.916C23.4701 24.1376 20.8583 26.7493 17.6367 26.7493",
    stroke: "#F2FCF7",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroplet);
export default __webpack_public_path__ + "static/media/droplet.f45900bc923726c8c7d148b4139785a7.svg";
export { ForwardRef as ReactComponent };